import { render, staticRenderFns } from "./mainDealerBarChart.vue?vue&type=template&id=28d4a079"
import script from "./mainDealerBarChart.vue?vue&type=script&lang=js"
export * from "./mainDealerBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports